<template>
  <div>
    <service-intro
      :title="trans('webinars.dashboard.title')"
      :description="trans('webinars.dashboard.webinars_description')"
      service-image="/images/webinars/webinar-image.svg"
      container-image="/images/webinars/bg-green.svg"
      :current-page="trans('webinars.dashboard.title')"
      prev-page="home"
      :prev-page-link="{ name: 'servicedashboard' }"
    >
      <div class="w-100" v-if="highlightedWebinars.length > 0">
        <h5 class="text-primary py-5">{{ nextSectionTitle }}</h5>
        <div v-for="webinar in highlightedWebinars">
          <webinar-event-card
            :webinar-id="webinar.id"
            :title="webinar.title"
            :text="webinar.text"
            :date="webinar.date"
            :is-augmented="webinar.augmented"
            :master="webinar.master"
            :time="webinar.time"
            :key="webinar.id"
            :registered="webinar.registered"
            :is-past="webinar.isPast"
            :topic-image="webinar.topicImage"
            :show-badge="showBadge(webinar)"
            :show-badge-number="showBadgeNumber(webinar)"
            :access-button-text="accessButtonText(webinar)"
          />
        </div>
      </div>
    </service-intro>
    <b-container class="py-5 max-width" fluid="" v-if="futureWebinars.length > 0">
      <h5 class="text-primary mb-4">{{ trans("webinars.dashboard.next_webinars") }}</h5>
      <div class="mb-4" v-for="webinar in futureWebinars">
        <webinar-event-card
          :webinar-id="webinar.id"
          :title="webinar.title"
          :text="webinar.text"
          :date="webinar.date"
          :is-augmented="webinar.augmented"
          :master="webinar.master"
          :time="webinar.time"
          :key="webinar.id"
          :registered="webinar.registered"
          :is-past="false"
          :topic-image="webinar.topicImage"
          :show-badge="showBadge(webinar)"
          :show-badge-number="showBadgeNumber(webinar)"
          :access-button-text="accessButtonText(webinar)"
        />
      </div>
      <div class="d-flex justify-content-end">
        <scroll-top-button variant="outline-secondary" v-if="pastWebinars.length < 1" />
      </div>
    </b-container>

    <div class="past-webinars" v-if="pastWebinars.length > 0">
      <b-container class="py-5 max-width" fluid="">
        <h5 class="text-primary mb-4">{{ trans("webinars.dashboard.past_webinars") }}</h5>
        <div class="mb-4" v-for="webinar in pastWebinars">
          <webinar-event-card
            :webinar-id="webinar.id"
            :title="webinar.title"
            :text="webinar.text"
            :date="webinar.date"
            :is-augmented="webinar.augmented"
            :master="webinar.master"
            :time="webinar.time"
            :key="webinar.id"
            :registered="webinar.registered"
            :is-past="true"
            :topic-image="webinar.topicImage"
            :access-button-text="accessButtonText(webinar)"
          />
        </div>
        <div class="d-flex justify-content-end">
          <scroll-top-button variant="outline-secondary" />
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import ServiceIntro from "../organisms/ServiceIntro";
import WebinarRegistration from "../organisms/webinars/WebinarRegistration";
import WebinarEventCard from "../organisms/webinars/WebinarEventCard";
import ScrollTopButton from "../atoms/ScrollTopButton";
import navMixin from "../mixins/navMixin";

export default {
  name: "WebinarDashboard",
  components: {
    ServiceIntro,
    WebinarRegistration,
    WebinarEventCard,
    ScrollTopButton,
  },
  props: {
    serviceName: String,
  },
  data() {
    return {
      highlightedWebinars: [],
      futureWebinars: [],
      pastWebinars: [],
      loading: false,
    };
  },
  mounted() {
    this.getWebinars();
    trackEvent("ReachDashboardView", {});
  },
  methods: {
    getWebinars() {
      this.loading = true;
      this.$axios
        .get(`/api/rest/webinar`)
        .then((res) => {
          this.loading = false;
          this.futureWebinars = res.data.webinars.futureWebinars;
          this.pastWebinars = res.data.webinars.pastWebinars;
          this.highlightedWebinars = res.data.webinars.highlightedWebinar;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    showBadge(webinar) {
      return webinar.augmented && !webinar.master.moduleCompleted;
    },
    showBadgeNumber(webinar) {
      return (
        webinar.augmented && webinar.stepData.currentStep > 0 && webinar.stepData.currentStep < 3
      );
    },
    accessButtonText(webinar) {
      return webinar.augmented && webinar.stepData.currentStep === 2
        ? this.trans("webinars.dashboard.complete_module")
        : this.trans("webinars.dashboard.access");
    },
  },
  computed: {
    nextSectionTitle() {
      return this.highlightedWebinars[0].registered
        ? this.trans("webinars.dashboard.last_activity")
        : this.trans("webinars.dashboard.happening_soon");
    },
  },
  mixins: [navMixin],
};
</script>

<style scoped lang="scss">
#image-bg-container {
  background: url("/images/webinars/bg-green.svg") no-repeat center bottom;
  background-size: 140%;
}

.past-webinars {
  background-color: $color-light;
}
</style>
